import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';

// Components
import AlertInfo from '@components/common/alert/AlertInfo';
import InstructionalText from '@components/ssap/notifications/InstructionalText';
import PageHeader from '../headers/PageHeader';
import SummaryItem from './pageIncludes/summary/SummaryItem';
import SourcesSummary from './pageIncludes/summary/summaryIncludes/SourcesSummary';

// ActionCreators & Selectors

import {
    selectIfFinalReviewPageActive,
    selectIfSsapInReviewMode,
    useExchangeAndProgramNames
} from '@reducers/appReducer';

// Utils

import { currencyTools } from '@utils/tools/currencyTools';
import { helperFunctions } from '@utils/tools/helperFunctions';
import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { dateMethods } from '@utils/dates/dateMethods';



const Page3_36_E1 = props => {

    const {
        data,
        data: {
            coverageYear
        },
        environment: {
            isState,
            language,
            localDates: {
                serverDate
            }
        }
    } = props;

    const {
        buttonContainer: ButtonContainer,
        currentHhm,
        hhmIndex,
        itfFeatureEnabled
    } = props;

    const {
        annualTaxIncome: {
            projectedIncome,
            reportedIncome
        },
        applicantGuid,
        incomes = [],
        expenses = [],
        name,
        monthlyReportedIncome,
        taxHouseholdComposition: {
            independentTaxFiler
        }
    } = currentHhm;

    const intlApi = useIntl();
    const isFinalSummaryPage = useSelector(selectIfFinalReviewPageActive);
    const isSsapInReviewMode = useSelector(selectIfSsapInReviewMode);
    const exchangeAndProgramNames = useExchangeAndProgramNames();

    const monthlyIncome = currencyTools.getMoneyFormat(monthlyReportedIncome, true) ;
    const currentMonth = dateMethods.getMonthByName(serverDate, language);
    const memberName = normalizeNameOfPerson(name);

    return (
        <Fragment>
            <div id="individualIncomeSummary">
                <div className="subsection">

                    <div className='summary__block margin-b-20' key={name.firstName}>
                        <div className="usa-grid usa-width-one-whole summary__header">
                            <PageHeader
                                text='ssap.subheader.persons_income_summary'
                                textReplacements={{
                                    personName: memberName
                                }}
                                headerClassName={'gi-heading-alt'}
                                additionalElement={(
                                    <ButtonContainer
                                        type="editButton_secondary"
                                        args={[hhmIndex]}
                                        ariaLabel={
                                            intlApi.formatMessage(
                                                { id: 'ssap.edit.income_summary' },
                                                { firstName: name.firstName, lastName: name.lastName },
                                            )
                                        }
                                    />
                                )}
                                additionalElementClassName={'header-btn'}
                            />
                            <SummaryItem
                                category='ssap.income_information.summary.total_income'
                                replacements={{
                                    personName: memberName,
                                    coverageYear,
                                    br: <br />,
                                    i: chunks => <i>{chunks}</i>
                                }}
                                value={ helperFunctions.getIncomeValueForRender(projectedIncome, reportedIncome) }
                                ignoreIntl={true}
                            />
                            <SummaryItem
                                category='ssap.income_information.summary.calculation'
                                replacements={{
                                    currentMonth,
                                    monthlyIncome,
                                    personName: memberName,
                                    br: <br />,
                                    i: chunks => <i>{chunks}</i>
                                }}
                                value={ monthlyIncome }
                                ignoreIntl
                            />

                            <SourcesSummary
                                { ...{
                                    applicantGuid,
                                    expenses,
                                    incomes,
                                    isFinalSummaryPage,
                                    isSsapInReviewMode,
                                    isState,
                                    memberName,
                                    previousData: data,
                                    reportedIncome,
                                    hhmIndex
                                } }
                            />
                        </div>
                        <InstructionalText
                            anchor='ssap.income_information.summary_link_anchor'
                            Component = {
                                <p data-instructions = 'instructional_text.income_information.summary.help_text'></p>
                            }
                            skipParsing={true}
                            replacements={ exchangeAndProgramNames }
                        />
                        {
                            itfFeatureEnabled && independentTaxFiler &&
                            <AlertInfo
                                { ...{
                                    id: 'ssap.income_information.summary.independent_tax_filer',
                                    textReplacements: { independentTaxFilerName: <b>{ memberName }</b> }
                                } }
                            />
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data
});

export default connect(mapStateToProps)(Page3_36_E1);
